<mat-toolbar id="nav-bar" color="primary">
    <a mat-flat-button routerLink="/" appHoverFocus class="accent">Home</a>
    <app-project-menu></app-project-menu>
    <a mat-flat-button appHoverFocus routerLink="resume">Resume</a>
    <a mat-flat-button appHoverFocus routerLink="links">Links</a>
</mat-toolbar>

<div id="page-container" class="mat-app-background">
    <router-outlet></router-outlet>
</div>